import { useQuery } from "@tanstack/react-query";
import { fetchPortfolioSnapshot } from "../lib/api";
import { queryKeys } from "../lib/queryKeys";

export function usePortfolioSnapshot() {
	return useQuery({
		queryKey: queryKeys.portfolioSnapshot,
		queryFn: () => fetchPortfolioSnapshot(),
	});
}
